import React, { useEffect, useRef, useState } from 'react';
import {useSelector} from "react-redux";
import axios from "axios";
import qs from "qs";
import { Toast } from "primereact/toast";
import { Controller, useForm } from "react-hook-form";
import { isBoolean } from "../../../Utils/HelperFunctions";
import {OpayoCheckout} from "../Gateways/Opayo/OpayoCheckout";
import { Card } from 'primereact/card';
import { Dialog } from "primereact/dialog";
import {PayGateCheckout} from "../Gateways/PayGate/PayGateCheckout";
import {PayFastCheckout} from "../Gateways/PayFast/PayFastCheckout";

export const CheckoutForm = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [currency, setCurrency] = useState('');
    const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false)
    const [opayoFormData, setOpayoFormData] = useState(null);
    const [pmtVendor, setPmtVendor] = useState(null);
    const [address1, setAddress1] = useState(props.address1);
    const [address2, setAddress2] = useState(props.address2);
    const [address3, setAddress3] = useState(props.address3);
    const [city, setCity] = useState(props.city);
    const [postalCode, setPostalCode] = useState(props.postalCode);
    const [country, setCountry] = useState(props.country);
    const [telNumber, setTelNumber] = useState(props?.telNumber);
    const [visible, setVisible] = useState(false);
    const [error, setError] = useState(null);
    const topup = useSelector(state => state.topup);
    const userAuth = useSelector(state => state.userAuth);
    const mopriSettings = useSelector(state => state.mopriSettings);
    const countries = useSelector(state => state.mopriSettings.countries);
    const myToast = useRef(null);
    const apiURL = useSelector(state => state.mopriSettings.mopriAPIURL);

    const showTermsConditions = () => {
        setVisible(true)
    }

    return (
        <>
            <Toast ref={myToast}/>
            {(mopriSettings.gatewaySettings.opayoActive &&
                (mopriSettings.internationalSettings.localizationCountry === 'IRL' ||
                 mopriSettings.internationalSettings.localizationCountry === 'GBR')) &&
            (
                <OpayoCheckout
                    amount={props.value}
                    cancelTopup={props.cancelTopup}
                    currency={props.currency}
                    allowCheckout={props.allowCheckout}
                />
            )}


            {(mopriSettings.gatewaySettings.payGateActive && (mopriSettings.internationalSettings.localizationCountry === 'ZAF' || mopriSettings.internationalSettings.localizationCountry === 'NAD')) &&
                <PayGateCheckout
                    amount={props.value}
                    cancelTopup={props.cancelTopup}
                    currency={props.currency}
                    allowCheckout={props.allowCheckout}
                />
            }

            {(isBoolean(mopriSettings.gatewaySettings.payFastActive) && mopriSettings.internationalSettings.localizationCountry === 'ZAF') &&
                <PayFastCheckout
                    amount={props.value}
                    cancelTopup={props.cancelTopup}
                    currency={props.currency}
                    allowCheckout={props.allowCheckout}
                />
            }


            <div className="col-12"
                style={{
                    fontSize: '0.8rem',
                    padding: '0rem',
                    cursor: 'pointer',
                    float: 'right',
                    textAlign: 'right' // Add this to right-align the text
                }}
                onClick={() => showTermsConditions()}
            >
                By proceeding with the checkout I agree to the Terms & Conditions
            </div>

            {/*<form onSubmit={handleSubmit(onSubmit)}>
                <div className="grid">


                    <div className="col-9">
                        <Controller
                            name="value"
                            control={control}
                            rules={{ required: 'Value is required.' }}
                            render={({ field }) => (
                                <>
                                    <div style={{paddingTop: '20px'}}>
                                        {(isBoolean(mopriSettings.gatewaySettings.payFastActive) && mopriSettings.internationalSettings.localizationCountry === 'ZAF') &&
                                            <div className="grid">
                                                <div className="col-12">
                                                    <div className="row" style={{width: '30px', float: 'left', paddingTop: '10px'}}>
                                                        <RadioButton inputId="f2" {...field} value="payFast" checked={field.value === 'payFast'} defaultValue={null}
                                                                     onClick={(e) => updatePmtVendor('PayFast')}
                                                        />
                                                    </div>
                                                    <div style={{float: 'left'}}>
                                                        <label htmlFor="f2" className="ml-1 mr-3" style={{paddingLeft: '30px'}}>
                                                            <img src="img/payfast-logo.png" alt="PayGate" height={"50px"}/>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        {(mopriSettings.gatewaySettings.payGateActive && (mopriSettings.internationalSettings.localizationCountry === 'ZAF' || mopriSettings.internationalSettings.localizationCountry === 'NAD')) &&
                                            <div className="grid">
                                                <div className="col-12">
                                                    <div className="row" style={{width: '30px', float: 'left', paddingTop: '10px'}}>
                                                        <RadioButton inputId="f3" {...field} inputRef={field.ref} value="PayGate" checked={field.value === 'PayGate'}
                                                                     onClick={(e) => updatePmtVendor('PayGate')}
                                                        />
                                                    </div>
                                                    <div style={{float: 'left'}}>
                                                        <label htmlFor="f3" className="ml-1 mr-3" style={{paddingLeft: '10px'}}>
                                                            <img src="img/PayGate-Card-Brand-Logos-PayGate.png" alt="PayGate" height={"50px"}/>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        }


                                    </div>
                                            </>
                                            )}
                                        />
                                    </div>
                    <div className="col-3">
                        <OrderSummary
                            value={props.value.toFixed(2)}
                        />
                    </div>

                    {(!mopriSettings.gatewaySettings.snapScanActive && !mopriSettings.gatewaySettings.payFastActive && !mopriSettings.gatewaySettings.sticittActive && !mopriSettings.gatewaySettings.payGateActive && (
                            mopriSettings.internationalSettings.localizationCountry === 'ZAF' || mopriSettings.internationalSettings.localizationCountry === 'NAD')) &&
                        <div className="col-12">
                            No payment methods available. Please contact your system administrator.
                        </div>
                    }
                    {((!mopriSettings.gatewaySettings.elavonActive && !mopriSettings.gatewaySettings.opayoActive) && mopriSettings.internationalSettings.localizationCountry === 'IRL') &&
                        <div className="col-12">
                            <ErrorMessage message="No payment methods available.  Please contact your system administrator." />
                        </div>
                    }
                    {(!mopriSettings.internationalSettings.localizationCountry) &&
                        <div className="col-12">
                            <ErrorMessage message="No country setup for Mopri.  Please contact your system administrator." />
                        </div>
                    }

                    {pmtVendor &&
                        <>
                            <div className="col-12">
                                <div className="p-fluid grid">
                                    <div className="field col-8"> </div>
                                    <div className="field col-2">
                                        <Button label="Cancel"
                                                severity="info" type="button"
                                                disabled={submitButtonDisabled}
                                                onClick={() => props.cancelTopup()}
                                        />
                                    </div>
                                    <div className="field col-2">
                                        <Button label="Checkout" severity="success"
                                                disabled={submitButtonDisabled}
                                        />
                                    </div>
                                </div>
                            </div>

                        </>
                    }

                </div>
            </form>
            */}
            <Dialog header="Terms & Conditions" visible={visible} style={{ width: '50vw' }} onHide={() => setVisible(false)}>
                <div dangerouslySetInnerHTML={{__html: mopriSettings.termsConditions}} />
            </Dialog>
        </>
    )

}
